<template>
  <div
    class="flex w-full gap-5 px-8 border-2 rounded py-7"
    :class="{
      'border-blue bg-blue': highlight,
      'border-black-light': !highlight,
    }"
  >
    <div class="flex items-center w-full gap-6.4">
      <div v-if="hasIconSlot" class="flex-shrink-0">
        <slot name="icon"></slot>
      </div>
      <div
        class="flex flex-grow w-full gap-4"
        :class="{
          'flex-row': size === 'wide',
          'flex-col': size === 'small',
        }"
      >
        <div
          class="flex justify-center flex-col flex-grow gap-4"
          :class="{
            'text-white': highlight,
            'text-black-light': !highlight,
          }"
        >
          <p v-if="title" class="font-bold uppercase text-paragraph">
            {{ title }}
          </p>
          <slot name="content">
            <p v-if="content">{{ content }}</p>
          </slot>
        </div>
        <div v-if="hasActionSlot || showButton" class="flex-shrink-0">
          <slot name="action">
            <button
              v-if="showButton"
              type="button"
              class="bg-blue hover:bg-blue-dark flex flex-row py-[13px] px-8 rounded text-white font-bold text-subtitle items-center"
              @click="handleAction"
            >
              {{ actionText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'wide'].includes(value),
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    actionText: {
      type: String,
      default: 'Action',
    },
    handleAction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    hasIconSlot() {
      return !!this.$slots.icon
    },
    hasActionSlot() {
      return !!this.$slots.action
    },
  },
}
</script>
